import React, { Component } from 'react';
import axios from 'axios';
import { authProvider } from '../authProvider';
import { QuoteView } from './QuoteView';
import { Button } from '@fluentui/react'

export class PrintableHistory extends Component {
    static displayName = PrintableHistory.name;

    constructor(props) {
        super(props)
        var rootUrl = window.location.protocol + '//' + window.location.host + '/';
        this.state = { rootUrl: rootUrl, token: "", isAuthorized: false, headers: {}, historyItem: null, id: props.match.params.id }

    }
    componentDidMount() {
        var self = this;
        authProvider.getAccessToken().then(function (result) {

            var tkn = result.accessToken;

            if (tkn) {

                self.setState({ token: tkn, isAuthorized: true, headers: { 'Authorization': "Bearer " + tkn }, editedEstimate: null });

                self.getHistory()

            }
            else {
                console.log("Token not acquired!")
            }
        });
    }
    getHistory() {
        if (this.state.id && this.state.id > 0) {
            axios.get(this.state.rootUrl + "SmsQuoteHistory/" + this.state.id, { headers: this.state.headers }).then(res => {
                if (res.data) {
                    this.setState({ historyItem: res.data });
                }
            });
        }
    }

    render() {

        const history = this.state.historyItem;
        return (
            <div><div>
                <Button className="d-print-none" style={{ verticalAlign: "top" }} text="Return to Estimate" onClick={() => { window.location.href = "/Estimate/" + history.smsEstimateId; }} />
                <Button className="d-print-none" style={{ verticalAlign: "top" }} text="Print" onClick={() => { window.print(); }} />
                </div>
                    {history &&
                    <QuoteView quote={history} />

                    }
                    {(!history) &&
                    <h4>Quote not loaded</h4>
                    }
            </div>
                );
    }
}